import React, { useEffect, useRef, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { Button, colors, Container, Paper } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { Save } from '@material-ui/icons';

export default function SubUnitForm(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        data,
        valueUnit,
        onSubmit,
        onChangeData,
        units,
        onChangeAutoData,
    } = props;
   
      
    const clasui = useStylesUiElemment();

    const onChangeSearch = (event) => {
        //  event.preventDefault();
        onSubmit();
    };
    return (
        <React.Fragment>

            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={3} sm={4} xs={6} >
                    <Autocomplete
                        value={valueUnit}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                            onChangeAutoData("unit", newValue);
                            document.getElementById("perc").focus();

                        }}
                        id="controllable-states-demo"
                        size="small"
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        options={units}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("forms:unit")}
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={2} md={3} sm={3} xs={4} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="perc"
                        label={t("forms:packaging")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="perc"
                        value={data.perc}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    document.getElementById("purch").focus();
                                }
                            },
                        }}
                        onChange={onChangeData("perc")} />
                </Grid>
                <Grid item lg={2} md={3} sm={3} xs={4} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="purch"
                        // autoFocus={true}
                        label={t('forms:purch-price')}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="purch"
                        value={data.purch}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    document.getElementById("sale").focus();
                                }
                            },
                        }}
                        onChange={onChangeData("purch")} />
                </Grid>
                <Grid item lg={2} md={3} sm={3} xs={4} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="sale"
                        label={t('forms:sale-price')}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="sale"
                        value={data.sale}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    document.getElementById("code").focus();
                                }
                            },
                        }}
                        onChange={onChangeData("sale")} />
                </Grid>
                <Grid item lg={3} md={4} sm={4} xs={6} >
                    <TextField
                        type="text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="code"
                        label={t('forms:barcode')}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="barcode"
                        value={data.barcode}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    if(data.unit>0 && data.perc>0 && data.sale!=""&& data.purch!=""){
                                    onSubmit(event);
                                    }
                                }
                            },
                        }}
                        onChange={onChangeData("barcode")} />
                </Grid>
                <Grid item  lg={1} md={1} sm={1} xs={2} >
                        <Grid item>

                            <Button
                                disabled={false}
                                variant="contained"
                                startIcon={<Save />}
                                size="large"
                                color='#fff'
                                style={{ backgroundColor:  '#cd5c5c', borderRadius: 0 ,color:'#fff'}}
                                className={[clasui.buttonB]}
                                onClick={(event) => onSubmit(event)}
                            >
                            </Button>
                        </Grid>
                    </Grid>
            
            </Grid>

        </React.Fragment >
    );

}